import { productClassNames } from "../AbstractCase";
import { ProductUnion } from "../ProductUnion";
import dayjs, { Dayjs } from "dayjs";

export function isDayjs(value: any): value is Dayjs {
  return value instanceof dayjs;
}

export function isValidProductClassName(value?: string): value is ProductUnion["productClassName"] {
  return (productClassNames as readonly string[]).includes(value || "");
}
